import { getContext, Symbols } from 'choerodon-ui/shared';
// We will never use default, here only to fix TypeScript warning
const MentionsContext = getContext(Symbols.MentionsContext, null);
export const MentionsContextProvider = MentionsContext.Provider;
export const MentionsContextConsumer = MentionsContext.Consumer;
